// client/src/components/TiptapEditor/MenuBar/AlignmentGroup.js
import React from "react";
import { Icon } from "semantic-ui-react"; // Usaremos los iconos de Semantic UI que ya tenemos en el proyecto

export const AlignmentGroup = ({ editor }) => {
  const alignments = [
    { name: "left", icon: "align left" },
    { name: "center", icon: "align center" },
    { name: "right", icon: "align right" },
    { name: "justify", icon: "align justify" },
  ];

  return (
    <>
      {alignments.map((alignment) => (
        <button
          key={alignment.name}
          type="button"
          // El comando es setTextAlign, pasándole el valor deseado
          onClick={() =>
            editor.chain().focus().setTextAlign(alignment.name).run()
          }
          // La comprobación 'isActive' requiere un objeto con la propiedad 'textAlign'
          className={
            editor.isActive({ textAlign: alignment.name }) ? "is-active" : ""
          }
        >
          <Icon name={alignment.icon} />
        </button>
      ))}
    </>
  );
};
